import { PortfolioPriceBasis } from './user-setting.model';

/** One مبنای قیمت row: the option, and the line under it when it needs one. */
export interface PriceBasisOption {
	value: PortfolioPriceBasis;
	label: string;
	/** Rendered under the label; only خودکار has a rule worth spelling out. */
	description: string | null;
}

/**
 * مبنای قیمت, in the order the handoff lists the options.
 *
 * Shared by the two screens that offer the choice — تنظیمات پرتفوی on the holdings
 * page and the پرتفوی section of the تنظیمات page — so they cannot drift into
 * offering different options, or the same options in a different order.
 */
export const PORTFOLIO_PRICE_BASIS_OPTIONS: readonly PriceBasisOption[] = [
	{
		value: 'auto',
		label: 'خودکار',
		description:
			'در ساعات معاملات محاسبات بر اساس قیمت آخرین معامله و بعد از ساعت معاملات بر اساس قیمت پایانی انجام می‌شود.'
	},
	{ value: 'lastTradedPrice', label: 'آخرین قیمت', description: null },
	{ value: 'closingPrice', label: 'قیمت پایانی', description: null }
];
